module.exports = __webpack_public_path__ + "img/pla_logo_scroll.242bbd57.png";